import { PaginatedResponse } from './common'
import { User } from '../models/User'
import { apiClient } from './apiClient'

export const getUsersList = (): Promise<PaginatedResponse<User[]>> => {
  return apiClient.get('/user').then((res) => res.data)
}
